export default __webpack_public_path__ + "static/IBMPlexSans-Regular-e8511383d0e9c278a123930ec3327e3d.woff";